import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  padding: 80px 0;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

const Title = styled.div`
  font-size: 42px;
  font-weight: 600;
  color: #343a40;
`;

const SubTitle = styled.div`
  font-size: 18px;
  color: #6c757d;
  line-height: 1.6;
`;

const ContactGrid = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1000px;
`;

const ContactCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 35px;
  border: 1px solid #dee2e6;
  text-align: center;
`;

const ContactIcon = styled.div`
  font-size: 36px;
  margin-bottom: 15px;
  color: #007bff;
`;

const ContactTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 12px;
`;

const ContactInfo = styled.div`
  font-size: 16px;
  color: #6c757d;
  line-height: 1.6;
`;

const ContactLink = styled.a`
  color: #007bff;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ContactSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>Contact Us</Title>
            <SubTitle>
              궁금하신 사항이 있으시거나 함께 일하고 싶으시다면 언제든 연락주세요.
              <br />
              빠른 시일 내에 답변드리겠습니다.
            </SubTitle>
          </Header>

          <ContactGrid>
            <ContactCard>
              <ContactIcon>📧</ContactIcon>
              <ContactTitle>이메일</ContactTitle>
              <ContactInfo>
                <ContactLink href="mailto:contact@followingmoments.com">
                  contact@followingmoments.com
                </ContactLink>
              </ContactInfo>
            </ContactCard>


          </ContactGrid>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default ContactSection;
